import { createAppAsyncThunk } from '../../../../common/thunk';
import { OnboardingRequest } from '../../onboardingRequest';
import OnboardingServices from '../../../../services/onboarding.services';
import { ConfigurationState } from './configurationSlice';

export interface ConfigurationPatchRequestData {
  template: string;
  color: string;
  subdomain: string;
  googleAnalytics: string;
}

export const prepareConfiguration = (configuration: ConfigurationState): ConfigurationPatchRequestData => {
  const { template, domain, googleAnalyticsCode } = configuration;
  return {
    template: template.template,
    color: template.color,
    subdomain: domain,
    googleAnalytics: googleAnalyticsCode,
  };
};

export const confirmConfigurationStep = createAppAsyncThunk('onboarding/confirmConfiguration', (requestData: OnboardingRequest) => {
  const id = requestData.id;
  if (!requestData.configuration) {
    throw Error('Missed configuration data');
  }
  return OnboardingServices.confirmOnboardingConfiguration(id, requestData.configuration).then(response => response.data);
});
